<template>
  <div class="row">
    <div class="col-xs-12" >

      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 ">
          <div class="form-group ">
            <div class="text-right">
              <button type="button" class="btn btn-info" @click="openModal"> <i aria-hidden="true" class="fa fa-robot"></i> &nbsp; AI Assistance</button> <br>
            </div>
            <label for="title" class="required">{{titleLabel}}
              <span v-if="errorTitle" class="error">{{ errorTitle }}</span>
            </label>
            <input v-model="question.title" id="title" class="form-control" placeholder="" required max="100" :class="{'has-error' : errorTitle, 'has-success' : errorTitle === false}">
            <span class="help-block m-b-none">{{titleHelp}}</span>
          </div>
        </div>

      </div>

      <div class="row">
<!--        <div class="col-xs-6">
          <div class="form-group " >
            <label for="companyProfile" class="required">Company Profile
              <span v-if="errorCompanyProfile" class="error">{{ errorCompanyProfile }}</span>
            </label>
            <textarea v-model="question.company_profile" id="companyProfile" class="form-control"
                      placeholder="A world leader in aeronautics, an innovative enterprise in the food industry sector"
                      rows="3" cols="3"
                      :class="{'has-error' : errorCompanyProfile, 'has-success' : errorCompanyProfile === false}"
                      required></textarea>
            <span class="help-block m-b-none">In a few words, make it attractive !</span>
          </div>
        </div>-->
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
          <div class="form-group ">
            <label for="objective" class="required">{{objectiveLabel}}
              <span v-if="errorObjective" class="error">{{ errorObjective }}</span>
            </label>
            <textarea v-model="question.objective" id="objective" class="form-control"
                      :placeholder="objectiveDefaultText"
                      rows="3" cols="3"
                      :class="{'has-error' : errorObjective, 'has-success' : errorObjective === false, 'text-placeholder' : question.objective === objectiveDefaultText}"
                      required></textarea>
            <span class="help-block m-b-none">{{objectiveHelp}}</span>
          </div>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
          <div class="form-group " >
            <label for="issue" class="required">{{issueLabel}}
              <span v-if="errorIssue" class="error">{{ errorIssue }}</span>
            </label>
            <textarea v-model="question.issue" id="issue" class="form-control"
                      :placeholder="issueDefaultText"
                      rows="3" cols="3"
                      :class="{'has-error' : errorIssue, 'has-success' : errorIssue === false , 'text-placeholder' : question.issue === issueDefaultText}"
                      required></textarea>
            <span class="help-block m-b-none">{{issueHelp}}</span>
          </div>
        </div>

      </div>
      <div  class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
          <div class="form-group">
            <label for="other" class="required">{{expertInterestLabel}}
              <span v-if="errorExpertInterest" class="error">{{ errorExpertInterest }}</span>
            </label>
            <textarea v-model="question.expert_interest" id="other" class="form-control"
                      :placeholder="expertInterestDefaultText"
                      :class="{'has-error' : errorExpertInterest, 'has-success' : errorExpertInterest === false, 'text-placeholder' : question.expert_interest === expertInterestDefaultText}"
                      rows="3" cols="3"></textarea>
            <span class="help-block m-b-none">{{ expertInterestHelp }}</span>
          </div>
        </div>
      </div>

      <div v-if="workflowId === 2" class="modal fade in hmodal-info" id="modalQuestionAI" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div style="display: block;" class="color-line"></div>
            <div class="modal-header">
              <button type="button" @click="closeModal" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 class="modal-title  text-capitalize text-center">AI assistance for question specification</h4>
            </div>
            <div class="modal-body text-center m-t m-b">
              <div class="row m-t-xs m-b">
                <div class="col-sm-12 text-left">
                  <div class="form-group">
                    <label class="text-left" for="boxName">Describe the aim of your question in as few words as possible </label>
                    <input type="text" class="form-control" v-model="objectQuestion" id="objectQuestion" placeholder="Example : improving the lubrication of mechanical parts using biomimicry">
                  </div>
                  <div class="form-group">
                    <label class="text-left" for="boxName">Describe your company in a few words</label>
                    <input type="text" class="form-control" v-model="companyName" id="companyName" placeholder="Example : World leader in the design of complex mechanical parts">
                  </div>
                </div>
                <div class="col-sm-12 text-right">
                  <button type="button" @click="closeModal" class="btn btn-default" data-dismiss="modal" aria-hidden="true">Close</button>
                  <vue-ladda type="button" :disabled="!objectQuestion || !companyName" :loading="submitAI.loading" class="btn btn-info" @click="generateAichat" :data-style="submitAI.dataStyle">Generate</vue-ladda>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-else-if="workflowId === 3" class="modal fade in hmodal-info" id="modalQuestionAITechOffer" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div style="display: block;" class="color-line"></div>
            <div class="modal-header">
              <button type="button" @click="closeModal" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 class=" modal-title  text-capitalize text-center">AI assistance for Tech Offer</h4>
            </div>
            <div class="modal-body text-center m-t m-b">
              <div class="row m-t-xs m-b">
                <div class="col-sm-12 text-left">
                  <div class="form-group">
                    <label class="text-left" for="boxName">Describe your solution in as few words as possible </label>
                    <input type="text" class="form-control" v-model="objectQuestion" id="objectQuestion" placeholder="Example: using biomimicry to improve the lubrication of mechanical parts">
                  </div>
                  <div class="form-group">
                    <label class="text-left" for="boxName">Describe your company in a few words</label>
                    <input type="text" class="form-control" v-model="companyName" id="companyName" placeholder="Example: World leader in the design of complex mechanical parts">
                  </div>
                </div>
                <div class="col-sm-12 text-right">
                  <button type="button" @click="closeModal" class="btn btn-default" data-dismiss="modal" aria-hidden="true">Close</button>
                  <vue-ladda type="button" :disabled="!objectQuestion || !companyName" :loading="submitAI.loading" class="btn btn-info" @click="generateAichat" :data-style="submitAI.dataStyle">Generate</vue-ladda>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>
<style scoped>
  .text-placeholder{color:#acacac;
    font-style: italic;  }
</style>
<script>

import VueLadda from 'vue-ladda'

export default {
  components: {VueLadda},
  name: 'QuestionStep1',
  props: ['projectId', 'question', 'workflowId'],
  data () {
    return {
      titleLabel: this.workflowId === 3 ? 'Tech offer title' : 'Question title',
      titleHelp: 'Use keywords that will catch the attention of the targeted audience (100 characters)',
      objectiveLabel: this.workflowId === 3 ? 'Your company and what you have achieved' : 'Your company and objective',
      objectiveDefaultText: this.workflowId === 3 ? 'A world leader in chemical processing has invented a novel technique to mass product janus particles'
        : 'A world leader in aeronautics, an innovative enterprise in the food industry sector is looking for an improved method for biochar production',
      objectiveHelp: this.workflowId === 3 ? 'In a few words, introduce your company and the technology you have developed'
        : 'Introduce your company (a few words) and define the objective you are trying to attain',
      issueLabel: this.workflowId === 3 ? 'Why is it better than today\'s solutions' : 'Issue(s) that prevent you from achieving the objective today',
      issueHelp: this.workflowId === 3 ? 'Express in what aspects your technique is different / better.'
        : 'Explain why your objective cannot easily be attained, what is difficult.',
      issueDefaultText: this.workflowId === 3 ? 'this technique is 10x more economical than conventional techniques and is environmentally safe'
        : 'The production method must improve the resilience of the produced material and be low temperature (below 200 °C)',
      expertInterestLabel: this.workflowId === 3 ? 'what you expect from the other parties' : 'What\'s in it for the other parties',
      expertInterestDefaultText: this.workflowId === 3 ? 'Further details will be revealed to specialists willing to investigate the application of the solution to their industry; collaboration or funding opportunities will be explored for the full development of the solution.'
        : 'In exchange for a proposal / good contact name /compelling idea (...) we are willing to offer a long term collaboration / a technology transfer / a one year contact / a reward (...)',
      expertInterestHelp: this.workflowId === 3 ? 'Explain why the other party should pay attention' : 'Explain why the expert(s) should pay attention',
      errorTitle: null,
      errorCompanyProfile: null,
      errorObjective: null,
      errorIssue: null,
      errorExpertInterest: null,
      companyName: null,
      submitAI: {
        loading: false,
        'dataStyle': 'zoom-in'
      },
      objectQuestion: null,
      promptQuestion: '[%prompt_question_ia%]',
      promptQuestionTT: '[%prompt_question_ia_tt%]'
    }
  },
  methods: {
    submitStep: function () {
      return new Promise((resolve, reject) => {
        let method = (this.question.id === null ? 'post' : 'patch')

        this.errorTitle = null
        this.errorCompanyProfile = null
        this.errorObjective = null
        this.errorIssue = null
        this.errorExpertInterest = null

        this.axios[method]('/question/' + (method === 'patch' ? this.question.id : ''), {
          project_id: this.projectId,
          step: 1,
          title: this.question.title,
          company_profile: this.question.company_profile,
          objective: this.question.objective,
          issue: this.question.issue,
          expert_interest: this.question.expert_interest
        })
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
            let errors = error.response.data.errors

            if (typeof errors['title'] !== 'undefined') {
              this.errorTitle = errors['title'][0]
            } if (typeof errors['company_profile'] !== 'undefined') {
              this.errorCompanyProfile = errors['company_profile'][0]
            } if (typeof errors['objective'] !== 'undefined') {
              this.errorObjective = errors['objective'][0]
            } if (typeof errors['issue'] !== 'undefined') {
              this.errorIssue = errors['issue'][0]
            } if (typeof errors['expert_interest'] !== 'undefined') {
              this.errorExpertInterest = errors['expert_interest'][0]
            }
          })
      })
    },
    openModal () {
      if (this.workflowId === 2) {
        $('#modalQuestionAI').show()
      } else {
        $('#modalQuestionAITechOffer').show()
      }
    },
    closeModal () {
      if (this.workflowId === 2) {
        $('#modalQuestionAI').hide()
      } else {
        $('#modalQuestionAITechOffer').hide()
      }
    },
    async generateAichat () {
      this.submitAI.loading = true
      let promptAichat = ''
      if (this.workflowId === 2) {
        promptAichat = this.promptQuestion + 'Apply the pre-prompt to the following : ' + this.objectQuestion + '; company = ' + this.companyName + ' \nAnd returns an json object with five elements (title, challenge_overview (issue, objective, expert_interest), challenge_details)' + '\n For elements challenge_details concatenate sub elements into one  '
      } else {
        promptAichat = this.promptQuestionTT + 'Apply the pre-prompt to the following offer : ' + this.objectQuestion + '; company = ' + this.companyName + ' \n And returns an json object with five elements (title, challenge_overview (issue, objective, expert_interest), challenge_details)' + '\n For elements challenge_details concatenate sub elements into one  '
      }
      this.axios.post('/search/chatai/prompt', { prompt: promptAichat })
        .then((response) => {
          if (response.data && response.data.aichat) {
            let cleanedResponse = response.data.aichat.replace(/```json/g, '').replace(/```/g, '')
            let resp = JSON.parse(cleanedResponse)
            this.question.title = resp.title
            this.question.objective = resp.challenge_overview.objective
            this.question.issue = resp.challenge_overview.issue
            this.question.expert_interest = resp.challenge_overview.expert_interest
            let longDescription = resp.challenge_details ? resp.challenge_details : null
            this.$emit('update-long-description', longDescription)
          }
        })
        .catch((_error) => {
          this.$notify({
            type: 'warning',
            title: 'Erreur lors de l\'exécution de la requête AI, veuillez modifier ou réessayer',
            placement: 'bottom-right'
          })
          this.submitAI.loading = false
        })
        .finally(() => {
          this.submitAI.loading = false
          if (this.workflowId === 2) {
            $('#modalQuestionAI').hide()
          } else {
            $('#modalQuestionAITechOffer').hide()
          }
        })
    }
  },
  mounted () {
    this.question.objective = this.question.objective == null ? this.objectiveDefaultText : this.question.objective
    this.question.issue = this.question.issue == null ? this.issueDefaultText : this.question.issue
    this.question.expert_interest = this.question.expert_interest == null ? this.expertInterestDefaultText : this.question.expert_interest

  }
}
</script>



// WEBPACK FOOTER //
// src/components/question/QuestionStep1.vue